import { render, staticRenderFns } from "./HumanizedNumber.vue?vue&type=template&id=0ceaa2d8&"
import script from "./HumanizedNumber.vue?vue&type=script&lang=js&"
export * from "./HumanizedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HumanizedNumber.vue"
export default component.exports